import React from 'react';

import type { MessageDescriptor } from 'react-intl';

import type { QuickInsertItem } from '@atlaskit/editor-common/provider-factory';
import { createQuickInsertMatcher } from '@atlaskit/editor-common/quick-insert/create-quick-insert-matcher';
import {
	BLOCK_TEMPLATES_SECTION,
	getBlockTemplateMenuItem,
} from '@atlaskit/editor-common/quick-insert/keys';
import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';
import type { RegisterMenuItem } from '@atlaskit/editor-ui-control-model/types';
import type { Snippet } from '@atlassian/editor-snippets-provider/types';

import type { SnippetsPlugin } from '../../snippetsPluginType';

import { SnippetQuickInsertMenuItem } from './SnippetQuickInsertMenuItem';

type Params = {
	api: ExtractInjectionAPI<SnippetsPlugin> | undefined;
	getItem: (
		snippet: Snippet,
		api: ExtractInjectionAPI<SnippetsPlugin> | undefined,
		intl: {
			formatMessage: (
				descriptor: MessageDescriptor,
				values?: Record<string, string | number | boolean | Date>,
			) => string;
		},
	) => QuickInsertItem;
	snippets: Snippet[];
};

export const getSnippetQuickInsertComponents = ({
	api,
	getItem,
	snippets,
}: Params): RegisterMenuItem[] =>
	snippets.map((snippet, rank) => {
		const menuItem = getBlockTemplateMenuItem(snippet.snippetId);
		return {
			key: menuItem.key,
			type: menuItem.type,
			parents: [
				{
					key: BLOCK_TEMPLATES_SECTION.key,
					type: BLOCK_TEMPLATES_SECTION.type,
					rank,
				},
			],
			match: createQuickInsertMatcher(({ formatMessage }) => {
				const item = getItem(snippet, api, { formatMessage });
				return {
					description: item.description,
					keywords: item.keywords,
					shortcut: item.keyshortcut,
					title: item.title,
				};
			}),
			component: () => <SnippetQuickInsertMenuItem api={api} getItem={getItem} snippet={snippet} />,
		};
	});
